import { OrderDirection, SortOrder } from 'common/utils/commonTypes';
import { TABLE_ROWS } from 'common/constants';
import { AccessGroupsVariables } from './__generated__/AccessGroups';
import { AccessGroupsOrderBy } from 'common/types/globalTypes';

type OrderLookup = {
  [direction in OrderDirection]: AccessGroupsOrderBy[];
};

const orderByMap = new Map<string, OrderLookup>([
  [
    'name',
    {
      [OrderDirection.ASC]: ['NAME_ASC'],
      [OrderDirection.DESC]: ['NAME_DESC'],
    },
  ],
  [
    'description',
    {
      [OrderDirection.ASC]: ['DESCRIPTION_ASC'],
      [OrderDirection.DESC]: ['DESCRIPTION_DESC'],
    },
  ],
]);

export const toOrderByVariable = (sort?: SortOrder) => {
  const defaultOrderBy: AccessGroupsOrderBy[] = ['NAME_ASC', 'PRIMARY_KEY_ASC'];
  const orderByArray: AccessGroupsOrderBy[] = ['PRIMARY_KEY_ASC'];
  if (!sort) return defaultOrderBy;
  const orderBy = orderByMap.get(sort.column)?.[sort.direction];
  return Array.from(new Set([...(orderBy ? orderBy : []), ...orderByArray]));
};

export const onHandleSearch = (sortOrderParam: SortOrder | undefined) => {
  const variables: AccessGroupsVariables = {
    first: TABLE_ROWS,
    orderBy: toOrderByVariable(sortOrderParam),
  };
  return {
    queryVariables: variables,
  };
};
